import ReactGA from "react-ga4";

// UX-12. GA4 used to be set up three times: a gtag snippet in public/index.html, and
// ReactGA.initialize() in both App.js and pages/index.jsx. Each gtag('config') sends its
// own automatic page_view, and pages/index.jsx sends one more on mount — so every first
// load counted as several page views, and gtag.js was downloaded twice.
//
// Now this is the only place GA is set up. The automatic page_view is off, and
// pages/index.jsx sends exactly one page view per route, the first load included.
export const GA_MEASUREMENT_ID = "G-ERC3BXEZ3P";

let initialised = false;

export const initAnalytics = () => {
  if (initialised) return;
  initialised = true;
  ReactGA.initialize(GA_MEASUREMENT_ID, { gtagOptions: { send_page_view: false } });
};

export const trackPageView = (page) => {
  ReactGA.send({ hitType: "pageview", page });
};
